export default __webpack_public_path__ + "static/media/biz-card-pic.58d8d846.jpg";